import {Accordion, AccordionSummary, Typography} from "@mui/material"
import {HighlightOff as OptOutOfCommIcon} from "@mui/icons-material"
import React from "react"
import styled from "styled-components"

import {CustomerEmailCommunicationOptedActivityPayload} from "@indebted/api"

function EmailCommunicationsOptedOutActivity(
	panelId: number,
	{Title, HappenedAt}: {Title: string; HappenedAt: string; Payload: CustomerEmailCommunicationOptedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => void,
	classes: {summary: string},
) {
	return (
		<AccordionNoContent expanded={false}>
			<AccordionSummary>
				<OptOutOfCommIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
		</AccordionNoContent>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {EmailCommunicationsOptedOutActivity}
